


import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function QualityOOPage() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [idSearch, setIdSearch] = useState("");
  const [phoneSearch, setPhoneSearch] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  // const isAgent = user?.role === "agent";
  const canSeeCreatedBy = user?.role === "admin" || user?.role === "quality";
  const navigate = useNavigate();

  // ================= FETCH QUALITY OO LEADS =================
  const fetchQualityOOLeads = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        "/leads/disposition/Quality OO"
      );

      setLeads(response.data.data || []);
    } catch (error) {
      console.error(
        "Quality OO Leads Error:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQualityOOLeads();
  }, []);

  // ================= SEARCH FILTER =================
  const filteredLeads = leads.filter((lead) => {
    const idTerm = idSearch.trim().toLowerCase();
    const phoneTerm = phoneSearch.trim().toLowerCase();

    const idOk = !idTerm || String(lead.id).toLowerCase().includes(idTerm);
    const phoneOk = !phoneTerm || (lead.business_phone || "").toLowerCase().includes(phoneTerm);

    return idOk && phoneOk;
  });

  const hasActiveSearch = idSearch.trim() || phoneSearch.trim();

  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-black text-slate-800">
            Quality OO Leads
          </h1>

          <p className="text-sm text-slate-500 mt-1">
            Total Leads: {filteredLeads.length}
          </p>
        </div>
      </div>

      {/* SEARCH BARS */}
      <div className="flex flex-wrap gap-3 mb-6">

        {/* ID Search */}
        <div className="relative w-full sm:w-56">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"
            fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
          </svg>
          <input
            type="text"
            value={idSearch}
            onChange={(e) => setIdSearch(e.target.value)}
            placeholder="Search by ID..."
            className="w-full pl-9 pr-9 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
          {idSearch && (
            <button
              onClick={() => setIdSearch("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>

        {/* Phone Search */}
        <div className="relative w-full sm:w-56">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"
            fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
          </svg>
          <input
            type="text"
            value={phoneSearch}
            onChange={(e) => setPhoneSearch(e.target.value)}
            placeholder="Search by phone..."
            className="w-full pl-9 pr-9 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
          {phoneSearch && (
            <button
              onClick={() => setPhoneSearch("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>

        {/* Clear both */}
        {hasActiveSearch && (
          <button
            onClick={() => { setIdSearch(""); setPhoneSearch(""); }}
            className="px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50 hover:bg-slate-100 text-slate-600 text-sm font-semibold transition"
          >
            Clear filters
          </button>
        )}
      </div>

      {/* LOADING */}
      {loading ? (
        <div className="bg-white rounded-2xl border border-slate-200 p-10 text-center text-slate-500">
          Loading quality OO leads...
        </div>
      ) : filteredLeads.length === 0 ? (
        <div className="bg-white rounded-2xl border border-slate-200 p-10 text-center">
          <p className="text-slate-500">
            {hasActiveSearch ? "No leads match your search" : "No quality OO leads found"}
          </p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              {/* TABLE HEADER */}
              <thead className="bg-slate-50 border-b border-slate-200">
                <tr>
                  <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    ID
                  </th>

                  <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    Business Name
                  </th>

                  <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    Supply Details
                  </th>


                  <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    Phone
                  </th>

                  <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    Supplier
                  </th>

                  <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    Review Status
                  </th>
                  {canSeeCreatedBy && (
                    <th className="text-left px-5 py-4 font-semibold text-slate-600">
                      Created By
                    </th>
                  )}
                  <th className="text-left px-5 py-4 font-semibold text-slate-600">
                    Created Date
                  </th>
                </tr>
              </thead>

              {/* TABLE BODY */}
              <tbody>
                {filteredLeads.map((lead) => (
                  <tr
                    key={lead.id}
                    className="border-b border-slate-100 hover:bg-slate-50 transition"
                  >
                    {/* ID */}
                    <td className="px-5 py-4">

                      <button
                        onClick={() =>
                          navigate(`/quality00-leads/${lead.id}`)
                        }
                        className="text-blue-600 font-semibold hover:underline"
                      >
                        #{lead.id}
                      </button>

                    </td>

                    {/* BUSINESS */}
                    <td className="px-5 py-4">
                      <div className="font-semibold text-slate-800">
                        {lead.business_name || "-"}
                      </div>


                    </td>

                    {/* SUPPLY DETAILS */}
                    <td className="px-5 py-4">
                      {lead.validation_type === "elec" && (
                        <span className="text-sm font-medium text-slate-700">
                          MPAN: {lead.mpan || "-"}
                        </span>
                      )}

                      {lead.validation_type === "gas" && (
                        <span className="text-sm font-medium text-slate-700">
                          MPRN: {lead.mprn_no || "-"}
                        </span>
                      )}

                      {lead.validation_type === "both" && (
                        <div className="flex flex-col text-sm text-slate-700">
                          <span>
                            MPAN: {lead.mpan || "-"}
                          </span>

                          <span>
                            MPRN: {lead.mprn_no || "-"}
                          </span>
                        </div>
                      )}
                    </td>



                    {/* PHONE */}
                    <td className="px-5 py-4 text-slate-600">
                      {lead.business_phone || "-"}
                    </td>



                    {/* SUPPLIER */}
                    <td className="px-5 py-4 text-slate-600">
                      {lead.electricity_supplier ||
                        lead.gas_supplier ||
                        "-"}
                    </td>

                    {/* REVIEW STATUS */}
                    <td className="px-5 py-4">
                      <span className="inline-flex px-3 py-1 rounded-full text-xs font-semibold bg-purple-100 text-purple-700">
                        {lead.lead_disposition}
                      </span>
                    </td>
                    {canSeeCreatedBy && (
                      <td className="px-5 py-4 text-slate-500">
                        {lead.created_by_name}
                      </td>
                    )}
                    {/* CREATED DATE */}
                    <td className="px-5 py-4 text-slate-500">
                      {lead.created_at
                        ? new Date(
                          lead.created_at
                        ).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}